
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import loadMyProfile from "@dana/Store/Data/MyProfile/Handlers/GetMyProfileHandler";
import loadMyPublicProfile from "@dana/Store/Data/MyPublicProfile/Handlers/GetMyPublicProfileHandler";
import Zone from "@insite/client-framework/Components/Zone";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationStateDana) => {
    const session = getSession(state);
    return {
     
        myProfileState: state.myProfileState,
        session: getSession(state),
    }
};

export interface MyProfilePageStyles {
    page?: MobiusPageProps;

}

export const myProfilePageStyles: MyProfilePageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

const mapDispatchToProps = {
    loadMyProfile,
    loadCurrentCountries
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = myProfilePageStyles;
const MyProfilePage: React.FC<Props> = ({ id, loadMyProfile, loadCurrentCountries,myProfileState, session }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        loadCurrentCountries();
        loadMyProfile({ accountId: session?.userProfileId || API_URL_CURRENT_FRAGMENT });
        setIsLoading(myProfileState.isLoading);
    }, [session]);


    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyProfilePage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const MyProfilePageContext = "MyProfilePage";
